// eslint-disable-line global-require
import React from "react";
import styled from "styled-components";
import { count2str } from "../../utils";
import { SocialIcon } from "react-social-icons";

const SubscribeCount = styled.span`
  display: inline-block;
  padding: 0 5px;
  /* user-select: none; */
  vertical-align: top;
  white-space: nowrap;
  font-size: 0.9rem;
  width: fit-content;
  display: flex;
  align-items: center;
  /* text-decoration: none; */
  color: ${(props) => props.theme.colors.black};
`;

const Num = styled.a`
  text-decoration: none;
  color: ${(props) => props.theme.colors.black100};
  font-size: ${(props) => (props.big ? "1.1rem" : "1rem")};
  line-height: 1.65rem;

  @media (max-width: 450px) {
    font-size: ${(props) => (props.big ? "1.1rem" : "1rem")};
  }
`;

const Name = styled.a`
  color: ${(props) => props.theme.colors.black};
  text-decoration: none;
  font-size: 1rem;
  line-height: 1.65rem;
`;

const YouTubeButton = (props) => {
  return props.youtube ? (
    <SubscribeCount>
      <SocialIcon
        target="_blank"
        rel="noopener noreferrer"
        url={`https://www.youtube.com/channel/${props.youtube}`}
        network="youtube"
        style={{
          width: props.big ? 34 : 24,
          height: props.big ? 34 : 24,
          marginRight: props.big ? "0.8rem" : "0.5rem",
        }}
      />
      {props.channel_name ? (
        <Name
          target="_blank"
          rel="noopener noreferrer"
          href={`https://www.youtube.com/channel/${props.youtube}`}
        >
          {props.channel_name}
        </Name>
      ) : (
        props.subscribeCount && (
          <Num
            target="_blank"
            rel="noopener noreferrer"
            href={`https://www.youtube.com/channel/${props.youtube}`}
            big={props.big}
          >
            {count2str(props.subscribeCount)}人
          </Num>
        )
      )}
    </SubscribeCount>
  ) : (
    <div />
  );
};

export default YouTubeButton;
